import Vue from 'vue'
import VuePagination from 'vuejs-paginate'

Vue.component('vue-paginate', VuePagination)
